import { RevealGroup, RevealItem } from "@/lib/motion";
import { Section, SectionHeading, Tag } from "./primitives";
import { UTILITY } from "@/config/site";
import { Wallet, Store, Coins, Vote, Boxes, Code2 } from "lucide-react";

const ICONS = [Wallet, Store, Coins, Vote, Boxes, Code2];

export default function UtilitySection() {
  return (
    <Section id="utility">
      <SectionHeading
        eyebrow="Utility"
        title="Utility Beyond Speculation"
        lead="XVPR is designed as the functional core of the ecosystem. Several capabilities below are planned or future features and are not yet live."
      />
      <RevealGroup className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {UTILITY.map((u, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <RevealItem key={u.title} data-testid={`utility-${i}`}>
              <div className="group relative flex h-full flex-col gap-5 overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] p-7 transition-all duration-500 hover:border-white/20 hover:bg-white/[0.05]">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-gradient-to-br from-indigo-500/20 to-violet-500/10">
                    <Icon className="h-5 w-5 text-indigo-300" />
                  </span>
                  <Tag tone={u.tag === "FUTURE" ? "future" : "planned"}>{u.tag}</Tag>
                </div>
                <div>
                  <h3 className="font-display text-lg font-bold uppercase tracking-tight text-white">{u.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-gray-400">{u.body}</p>
                </div>
                <span className="pointer-events-none absolute -bottom-16 -right-16 h-40 w-40 rounded-full bg-indigo-600/10 blur-[60px] opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              </div>
            </RevealItem>
          );
        })}
      </RevealGroup>
    </Section>
  );
}
